import { getZrmListingInfo, getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackEvent } from '../../../../client/analytics';

import type { ZrmClickstreamListing, ZrmClickstreamUser } from '@zg-rentals/clickstream';

const EVENT_IDS = {
  UPCOMING_TOURS_MORE_TOURS_CTA: '7122',
  UPSELL_SET_TOUR_AVAILABILITY_CTA: '6636',
} as const;

// https://dataportal.zillowgroup.net/event-registry/7122
const UpcomingToursMoreToursCta = ({
  currentProperty,
  user,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '171',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.UPCOMING_TOURS_MORE_TOURS_CTA,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_property_overview',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'more_tours_cta',
      trigger_source_nm: 'tour_scheduling_module',
    },
    semantic: {
      semantic_event_nm: 'tour_scheduling_view_more_tours',
      topic_tag_txt: ['zrm_tour_scheduling'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/6636
const TourSchedulingUpsellSetTourAvailabilityCta = ({
  currentProperty,
  user,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.UPSELL_SET_TOUR_AVAILABILITY_CTA,
      event_type_version_id: '2',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_property_overview',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'tour_module',
      trigger_source_nm: 'setup_tour_availability',
    },
    semantic: {
      semantic_event_nm: 'tour_scheduling_entrypoint',
      topic_tag_txt: ['zrm_tour_scheduling', 'zrm_properties'],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });

const TouringPropertyDashboardCSEvents = {
  UpcomingToursMoreToursCta,
  TourSchedulingUpsellSetTourAvailabilityCta,
};

// Clickstream visualizer data-eventid attributes
UpcomingToursMoreToursCta.data_event_id = EVENT_IDS.UPCOMING_TOURS_MORE_TOURS_CTA;
TourSchedulingUpsellSetTourAvailabilityCta.data_event_id = EVENT_IDS.UPSELL_SET_TOUR_AVAILABILITY_CTA;

export default TouringPropertyDashboardCSEvents;
